module.exports = __webpack_public_path__ + "static/media/0017.d69e5a96.jpg";